import { forwardRef } from "react";
import { cn } from "@/lib/cn";
import {
  surfaceRoleAttributes,
  surfaceRoleClassName,
  type NativeSurfaceOptions,
  type SurfaceRole,
} from "./surface-contract";

type SurfaceProps = React.ComponentProps<"div"> & {
  surfaceRole: SurfaceRole;
} & NativeSurfaceOptions;

const Surface = forwardRef<HTMLDivElement, SurfaceProps>(
  ({ className, nativeGroup, nativeLevel, surfaceRole, ...props }, ref) => (
    <div
      ref={ref}
      {...props}
      className={cn(surfaceRoleClassName(surfaceRole), className)}
      {...surfaceRoleAttributes(surfaceRole, { nativeGroup, nativeLevel })}
    />
  ),
);
Surface.displayName = "Surface";

export { Surface };
export type { SurfaceProps };
